'use strict';

function findIndexBy(arr, fn) {

    var i = 0;
    var len = arr.length;

    for (; i < len; i++) {
        if (fn(arr[i]) === true) {
            return i;
        }
    }

    return -1;
}

module.exports = findIndexBy;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-datagrid/lib/utils/findIndexBy.js
 ** module id = 915
 ** module chunks = 0
 **/